// Comprehensive list of all world countries with ISO 3166-1 alpha-3 and alpha-2 codes
export const ALL_COUNTRIES = [
  { code: 'AFG', name: 'Afghanistan', flagCode: 'af' },
  { code: 'ALB', name: 'Albania', flagCode: 'al' },
  { code: 'DZA', name: 'Algeria', flagCode: 'dz' },
  { code: 'AND', name: 'Andorra', flagCode: 'ad' },
  { code: 'AGO', name: 'Angola', flagCode: 'ao' },
  { code: 'ATG', name: 'Antigua and Barbuda', flagCode: 'ag' },
  { code: 'ARG', name: 'Argentina', flagCode: 'ar' },
  { code: 'ARM', name: 'Armenia', flagCode: 'am' },
  { code: 'AUS', name: 'Australia', flagCode: 'au' },
  { code: 'AUT', name: 'Austria', flagCode: 'at' },
  { code: 'AZE', name: 'Azerbaijan', flagCode: 'az' },
  { code: 'BHS', name: 'Bahamas', flagCode: 'bs' },
  { code: 'BHR', name: 'Bahrain', flagCode: 'bh' },
  { code: 'BGD', name: 'Bangladesh', flagCode: 'bd' },
  { code: 'BRB', name: 'Barbados', flagCode: 'bb' },
  { code: 'BLR', name: 'Belarus', flagCode: 'by' },
  { code: 'BEL', name: 'Belgium', flagCode: 'be' },
  { code: 'BLZ', name: 'Belize', flagCode: 'bz' },
  { code: 'BEN', name: 'Benin', flagCode: 'bj' },
  { code: 'BTN', name: 'Bhutan', flagCode: 'bt' },
  { code: 'BOL', name: 'Bolivia', flagCode: 'bo' },
  { code: 'BIH', name: 'Bosnia and Herzegovina', flagCode: 'ba' },
  { code: 'BWA', name: 'Botswana', flagCode: 'bw' },
  { code: 'BRA', name: 'Brazil', flagCode: 'br' },
  { code: 'BRN', name: 'Brunei', flagCode: 'bn' },
  { code: 'BGR', name: 'Bulgaria', flagCode: 'bg' },
  { code: 'BFA', name: 'Burkina Faso', flagCode: 'bf' },
  { code: 'BDI', name: 'Burundi', flagCode: 'bi' },
  { code: 'CPV', name: 'Cabo Verde', flagCode: 'cv' },
  { code: 'KHM', name: 'Cambodia', flagCode: 'kh' },
  { code: 'CMR', name: 'Cameroon', flagCode: 'cm' },
  { code: 'CAN', name: 'Canada', flagCode: 'ca' },
  { code: 'CAF', name: 'Central African Republic', flagCode: 'cf' },
  { code: 'TCD', name: 'Chad', flagCode: 'td' },
  { code: 'CHL', name: 'Chile', flagCode: 'cl' },
  { code: 'CHN', name: 'China', flagCode: 'cn' },
  { code: 'COL', name: 'Colombia', flagCode: 'co' },
  { code: 'COM', name: 'Comoros', flagCode: 'km' },
  { code: 'COG', name: 'Congo', flagCode: 'cg' },
  { code: 'COD', name: 'Congo (Democratic Republic)', flagCode: 'cd' },
  { code: 'CRI', name: 'Costa Rica', flagCode: 'cr' },
  { code: 'CIV', name: "Côte d'Ivoire", flagCode: 'ci' },
  { code: 'HRV', name: 'Croatia', flagCode: 'hr' },
  { code: 'CUB', name: 'Cuba', flagCode: 'cu' },
  { code: 'CYP', name: 'Cyprus', flagCode: 'cy' },
  { code: 'CZE', name: 'Czech Republic', flagCode: 'cz' },
  { code: 'DNK', name: 'Denmark', flagCode: 'dk' },
  { code: 'DJI', name: 'Djibouti', flagCode: 'dj' },
  { code: 'DMA', name: 'Dominica', flagCode: 'dm' },
  { code: 'DOM', name: 'Dominican Republic', flagCode: 'do' },
  { code: 'ECU', name: 'Ecuador', flagCode: 'ec' },
  { code: 'EGY', name: 'Egypt', flagCode: 'eg' },
  { code: 'SLV', name: 'El Salvador', flagCode: 'sv' },
  { code: 'GNQ', name: 'Equatorial Guinea', flagCode: 'gq' },
  { code: 'ERI', name: 'Eritrea', flagCode: 'er' },
  { code: 'EST', name: 'Estonia', flagCode: 'ee' },
  { code: 'SWZ', name: 'Eswatini', flagCode: 'sz' },
  { code: 'ETH', name: 'Ethiopia', flagCode: 'et' },
  { code: 'FJI', name: 'Fiji', flagCode: 'fj' },
  { code: 'FIN', name: 'Finland', flagCode: 'fi' },
  { code: 'FRA', name: 'France', flagCode: 'fr' },
  { code: 'GAB', name: 'Gabon', flagCode: 'ga' },
  { code: 'GMB', name: 'Gambia', flagCode: 'gm' },
  { code: 'GEO', name: 'Georgia', flagCode: 'ge' },
  { code: 'DEU', name: 'Germany', flagCode: 'de' },
  { code: 'GHA', name: 'Ghana', flagCode: 'gh' },
  { code: 'GRC', name: 'Greece', flagCode: 'gr' },
  { code: 'GRD', name: 'Grenada', flagCode: 'gd' },
  { code: 'GTM', name: 'Guatemala', flagCode: 'gt' },
  { code: 'GIN', name: 'Guinea', flagCode: 'gn' },
  { code: 'GNB', name: 'Guinea-Bissau', flagCode: 'gw' },
  { code: 'GUY', name: 'Guyana', flagCode: 'gy' },
  { code: 'HTI', name: 'Haiti', flagCode: 'ht' },
  { code: 'HND', name: 'Honduras', flagCode: 'hn' },
  { code: 'HUN', name: 'Hungary', flagCode: 'hu' },
  { code: 'ISL', name: 'Iceland', flagCode: 'is' },
  { code: 'IND', name: 'India', flagCode: 'in' },
  { code: 'IDN', name: 'Indonesia', flagCode: 'id' },
  { code: 'IRN', name: 'Iran', flagCode: 'ir' },
  { code: 'IRQ', name: 'Iraq', flagCode: 'iq' },
  { code: 'IRL', name: 'Ireland', flagCode: 'ie' },
  { code: 'ISR', name: 'Israel', flagCode: 'il' },
  { code: 'ITA', name: 'Italy', flagCode: 'it' },
  { code: 'JAM', name: 'Jamaica', flagCode: 'jm' },
  { code: 'JPN', name: 'Japan', flagCode: 'jp' },
  { code: 'JOR', name: 'Jordan', flagCode: 'jo' },
  { code: 'KAZ', name: 'Kazakhstan', flagCode: 'kz' },
  { code: 'KEN', name: 'Kenya', flagCode: 'ke' },
  { code: 'KIR', name: 'Kiribati', flagCode: 'ki' },
  { code: 'PRK', name: 'Korea (North)', flagCode: 'kp' },
  { code: 'KOR', name: 'Korea (South)', flagCode: 'kr' },
  { code: 'KWT', name: 'Kuwait', flagCode: 'kw' },
  { code: 'KGZ', name: 'Kyrgyzstan', flagCode: 'kg' },
  { code: 'LAO', name: 'Laos', flagCode: 'la' },
  { code: 'LVA', name: 'Latvia', flagCode: 'lv' },
  { code: 'LBN', name: 'Lebanon', flagCode: 'lb' },
  { code: 'LSO', name: 'Lesotho', flagCode: 'ls' },
  { code: 'LBR', name: 'Liberia', flagCode: 'lr' },
  { code: 'LBY', name: 'Libya', flagCode: 'ly' },
  { code: 'LIE', name: 'Liechtenstein', flagCode: 'li' },
  { code: 'LTU', name: 'Lithuania', flagCode: 'lt' },
  { code: 'LUX', name: 'Luxembourg', flagCode: 'lu' },
  { code: 'MDG', name: 'Madagascar', flagCode: 'mg' },
  { code: 'MWI', name: 'Malawi', flagCode: 'mw' },
  { code: 'MYS', name: 'Malaysia', flagCode: 'my' },
  { code: 'MDV', name: 'Maldives', flagCode: 'mv' },
  { code: 'MLI', name: 'Mali', flagCode: 'ml' },
  { code: 'MLT', name: 'Malta', flagCode: 'mt' },
  { code: 'MHL', name: 'Marshall Islands', flagCode: 'mh' },
  { code: 'MRT', name: 'Mauritania', flagCode: 'mr' },
  { code: 'MUS', name: 'Mauritius', flagCode: 'mu' },
  { code: 'MEX', name: 'Mexico', flagCode: 'mx' },
  { code: 'FSM', name: 'Micronesia', flagCode: 'fm' },
  { code: 'MDA', name: 'Moldova', flagCode: 'md' },
  { code: 'MCO', name: 'Monaco', flagCode: 'mc' },
  { code: 'MNG', name: 'Mongolia', flagCode: 'mn' },
  { code: 'MNE', name: 'Montenegro', flagCode: 'me' },
  { code: 'MAR', name: 'Morocco', flagCode: 'ma' },
  { code: 'MOZ', name: 'Mozambique', flagCode: 'mz' },
  { code: 'MMR', name: 'Myanmar', flagCode: 'mm' },
  { code: 'NAM', name: 'Namibia', flagCode: 'na' },
  { code: 'NRU', name: 'Nauru', flagCode: 'nr' },
  { code: 'NPL', name: 'Nepal', flagCode: 'np' },
  { code: 'NLD', name: 'Netherlands', flagCode: 'nl' },
  { code: 'NZL', name: 'New Zealand', flagCode: 'nz' },
  { code: 'NIC', name: 'Nicaragua', flagCode: 'ni' },
  { code: 'NER', name: 'Niger', flagCode: 'ne' },
  { code: 'NGA', name: 'Nigeria', flagCode: 'ng' },
  { code: 'MKD', name: 'North Macedonia', flagCode: 'mk' },
  { code: 'NOR', name: 'Norway', flagCode: 'no' },
  { code: 'OMN', name: 'Oman', flagCode: 'om' },
  { code: 'PAK', name: 'Pakistan', flagCode: 'pk' },
  { code: 'PLW', name: 'Palau', flagCode: 'pw' },
  { code: 'PAN', name: 'Panama', flagCode: 'pa' },
  { code: 'PNG', name: 'Papua New Guinea', flagCode: 'pg' },
  { code: 'PRY', name: 'Paraguay', flagCode: 'py' },
  { code: 'PER', name: 'Peru', flagCode: 'pe' },
  { code: 'PHL', name: 'Philippines', flagCode: 'ph' },
  { code: 'POL', name: 'Poland', flagCode: 'pl' },
  { code: 'PRT', name: 'Portugal', flagCode: 'pt' },
  { code: 'QAT', name: 'Qatar', flagCode: 'qa' },
  { code: 'ROU', name: 'Romania', flagCode: 'ro' },
  { code: 'RUS', name: 'Russia', flagCode: 'ru' },
  { code: 'RWA', name: 'Rwanda', flagCode: 'rw' },
  { code: 'KNA', name: 'Saint Kitts and Nevis', flagCode: 'kn' },
  { code: 'LCA', name: 'Saint Lucia', flagCode: 'lc' },
  { code: 'VCT', name: 'Saint Vincent and the Grenadines', flagCode: 'vc' },
  { code: 'WSM', name: 'Samoa', flagCode: 'ws' },
  { code: 'SMR', name: 'San Marino', flagCode: 'sm' },
  { code: 'STP', name: 'São Tomé and Príncipe', flagCode: 'st' },
  { code: 'SAU', name: 'Saudi Arabia', flagCode: 'sa' },
  { code: 'SEN', name: 'Senegal', flagCode: 'sn' },
  { code: 'SRB', name: 'Serbia', flagCode: 'rs' },
  { code: 'SYC', name: 'Seychelles', flagCode: 'sc' },
  { code: 'SLE', name: 'Sierra Leone', flagCode: 'sl' },
  { code: 'SGP', name: 'Singapore', flagCode: 'sg' },
  { code: 'SVK', name: 'Slovakia', flagCode: 'sk' },
  { code: 'SVN', name: 'Slovenia', flagCode: 'si' },
  { code: 'SLB', name: 'Solomon Islands', flagCode: 'sb' },
  { code: 'SOM', name: 'Somalia', flagCode: 'so' },
  { code: 'ZAF', name: 'South Africa', flagCode: 'za' },
  { code: 'SSD', name: 'South Sudan', flagCode: 'ss' },
  { code: 'ESP', name: 'Spain', flagCode: 'es' },
  { code: 'LKA', name: 'Sri Lanka', flagCode: 'lk' },
  { code: 'SDN', name: 'Sudan', flagCode: 'sd' },
  { code: 'SUR', name: 'Suriname', flagCode: 'sr' },
  { code: 'SWE', name: 'Sweden', flagCode: 'se' },
  { code: 'CHE', name: 'Switzerland', flagCode: 'ch' },
  { code: 'SYR', name: 'Syria', flagCode: 'sy' },
  { code: 'TWN', name: 'Taiwan', flagCode: 'tw' },
  { code: 'TJK', name: 'Tajikistan', flagCode: 'tj' },
  { code: 'TZA', name: 'Tanzania', flagCode: 'tz' },
  { code: 'THA', name: 'Thailand', flagCode: 'th' },
  { code: 'TLS', name: 'Timor-Leste', flagCode: 'tl' },
  { code: 'TGO', name: 'Togo', flagCode: 'tg' },
  { code: 'TON', name: 'Tonga', flagCode: 'to' },
  { code: 'TTO', name: 'Trinidad and Tobago', flagCode: 'tt' },
  { code: 'TUN', name: 'Tunisia', flagCode: 'tn' },
  { code: 'TUR', name: 'Turkey', flagCode: 'tr' },
  { code: 'TKM', name: 'Turkmenistan', flagCode: 'tm' },
  { code: 'TUV', name: 'Tuvalu', flagCode: 'tv' },
  { code: 'UGA', name: 'Uganda', flagCode: 'ug' },
  { code: 'UKR', name: 'Ukraine', flagCode: 'ua' },
  { code: 'ARE', name: 'United Arab Emirates', flagCode: 'ae' },
  { code: 'GBR', name: 'United Kingdom', flagCode: 'gb' },
  { code: 'USA', name: 'United States', flagCode: 'us' },
  { code: 'URY', name: 'Uruguay', flagCode: 'uy' },
  { code: 'UZB', name: 'Uzbekistan', flagCode: 'uz' },
  { code: 'VUT', name: 'Vanuatu', flagCode: 'vu' },
  { code: 'VAT', name: 'Vatican City', flagCode: 'va' },
  { code: 'VEN', name: 'Venezuela', flagCode: 've' },
  { code: 'VNM', name: 'Vietnam', flagCode: 'vn' },
  { code: 'YEM', name: 'Yemen', flagCode: 'ye' },
  { code: 'ZMB', name: 'Zambia', flagCode: 'zm' },
  { code: 'ZWE', name: 'Zimbabwe', flagCode: 'zw' }
];

// Countries with detailed e-invoicing mandate information
export const MANDATE_COUNTRIES = [
  'DEU',
  'ITA',
  'ESP',
  'GRC',
  'FRA',
  'PRT',
  'DNK',
  'HUN',
  'ROU',
  'TWN',
  'SAU',
  'MYS',
  'IND',
  'JPN',
  'MEX',
  'CHN',
  'POL',
  'NZL',
  'AUS'
];
